import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=d5237efe"
import script from "./CategoryFilter.vue?vue&type=script&lang=js"
export * from "./CategoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports